import { AxiosRequest } from "../common/axios-request";
import {
  CREATE_COACH_BOOKING,
  DEACTIVATE_COACH_BOOKING,
  GET_ALL_COACH_BOOKING_LIST,
  GET_COACH_BOOKING_DETAILS,
  GET_COACH_BOOKING_LIST,
  PRINT_COACH_BOOKING_INVOICE,
  REFUND_COACH_BOOKING,
  DOWNLOAD_COACH_BOOKING_REPORT,
  CREATE_CUSTOMER_COACHING_BOOKING,
  GET_SESSION_GROUP_SLOTS,
  COACHING_BOOKING_SHARE_PAYMENT_LINK,
  PRINT_COACH_BOOKING_SUMMARY,
} from "../common/constant";

const GetCoachBookingDetails = (id: any) => {
  return AxiosRequest.get(GET_COACH_BOOKING_DETAILS.replace(":id", id));
};

const GetCoachBookingList = (payload: any) => {
  return AxiosRequest.get(GET_COACH_BOOKING_LIST(payload));
};

const DownloadCoachBookingReport = (payload: any) => {
  return AxiosRequest.get(DOWNLOAD_COACH_BOOKING_REPORT(payload));
};

const GetAllCoachBookingList = () => {
  return AxiosRequest.get(GET_ALL_COACH_BOOKING_LIST);
};

const CreateNewCoachBooking = (payload: any) => {
  return AxiosRequest.post(CREATE_COACH_BOOKING, payload, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

const RefundCoachBooking = (id: any, payload: any) => {
  return AxiosRequest.put(REFUND_COACH_BOOKING.replace(":id", id), payload);
};

const DeactivateCoachBooking = (id: any, payload: any) => {
  return AxiosRequest.put(DEACTIVATE_COACH_BOOKING.replace(":id", id), payload);
};

const PrintCoachBookingInvoice = (id: any) => {
  return AxiosRequest.get(PRINT_COACH_BOOKING_INVOICE.replace(":id", id));
};
const PrintCoachBookingSummary = (id: any) => {
  return AxiosRequest.get(PRINT_COACH_BOOKING_SUMMARY.replace(":id", id));
};

const CreateCoachingBookingEndUser = (payload: any) => {
  return AxiosRequest.post(CREATE_CUSTOMER_COACHING_BOOKING, payload);
};

const GetSessionSoltsByGroup = (id: any) => {
  return AxiosRequest.get(GET_SESSION_GROUP_SLOTS(id));
};

const CoachingBookingSharePaymentLink = (id: string) => {
  return AxiosRequest.put(COACHING_BOOKING_SHARE_PAYMENT_LINK(id), null);
};

export {
  GetCoachBookingDetails,
  GetCoachBookingList,
  GetAllCoachBookingList,
  CreateNewCoachBooking,
  RefundCoachBooking,
  DeactivateCoachBooking,
  PrintCoachBookingInvoice,
  DownloadCoachBookingReport,
  CreateCoachingBookingEndUser,
  GetSessionSoltsByGroup,
  CoachingBookingSharePaymentLink,
  PrintCoachBookingSummary,
};
